import React from "react";

const LinkPhoneNumber = () => (
  <a href={`tel:${import.meta.env.VITE_SUPPORT_PHONE_NUMBER}`}> {import.meta.env.VITE_SUPPORT_PHONE_NUMBER} </a>
);

export default LinkPhoneNumber;